import React from 'react'
import "./style.scss";
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { all_routes } from '../router/all_routes';
import { createPaymentIntent } from '../../services/pricing.service';


const PaymentFailed = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const routes: any = all_routes;
  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get("session_id");
  const planUuid = queryParams.get("plan_uuid");

  const handleRetryPayment = async () => {
    if (!planUuid) {
      toast.error("Plan UUID is missing. Please try again from the pricing page.");
      navigate(routes.pricing);
      return;
    }

    try {
      const response = await createPaymentIntent({ plan_uuid: planUuid });
      console.log("Retry payment response:", response.data);

      if (response.data.success && response.data.data?.url) {
        // Redirect to the Stripe checkout URL
        window.location.href = response.data.data.url;
      } else {
        toast.error(response?.data?.message || "Failed to initiate retry payment");
      }
    } catch (err: any) {
      toast.error(err.response?.data?.message || "An error occurred while retrying payment");
    }
  };


  return (
    <div className="payment-faild-page">
      <div className="content">
        <div className="container d-flex align-items-center justify-content-center">
          <div className="payment-faild-inner d-flex align-items-center justify-content-center">
            <div className="payment-faild-inner-2 text-center">
              <img
                className="img-fluid"
                src="/assets/img/cross-image.png"
                alt="Logo"
              />
              <h2 className='mt-4'>Payment Failed!</h2>
              <p className="text-center thank mb-2">We couldn't process your payment. Please review your details or try a different payment method.</p>
              <p className="text-center transaction">Transaction ID: 7P673144A3914662X</p>

              <div className='instructiona-area mb-4'>
                <h4>Instructions:</h4>
                <ul>
                  <li> Ensure your information is correct.</li>
                  <li>Verify that your bank has sufficient funds.</li>
                </ul>
              </div>

              <button
                type="submit"
                className="btn primaryButton  btn-primary d-inline-flex justify-content-center align-items-center w-100 btn-block"
                onClick={handleRetryPayment}
              >
                Retry payment
              </button>

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentFailed;